import React, { FC } from 'react';

interface Props {
  title: string;
  description: string;
}

const BasketEmpty: FC<Props> = ({ title, description }) => {
  return (
    <div className="py-24 flex flex-col items-center">
      <span className="page-heading-two text-center lg:mb-4 max-w-2xl">
        {title}
      </span>

      <p className="text-center text-grey-600 max-w-lg">{description}</p>
    </div>
  );
};

export default BasketEmpty;
